import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SearchDataAggregateService {

  public data: BehaviorSubject<Array<any>>;

  constructor() {
    this.data = new BehaviorSubject<Array<any>>([]);
  }

  public compile(d: Array<any>): void {
    if (d != undefined && d.length > 0) {
      this.data.next(d);
    }
  }

}
